var O = /* @__PURE__ */ ((E) => (E.TEXT_CONTENT = "TEXT_CONTENT", E.IMAGE = "IMAGE", E.VIDEO = "VIDEO", E))(O || {}), T = /* @__PURE__ */ ((E) => (E.PORTRAIT = "PORTRAIT", E.LANDSCAPE = "LANDSCAPE", E))(T || {}), L = /* @__PURE__ */ ((E) => (E.LAYOUT_1 = "LAYOUT_1", E.LAYOUT_2 = "LAYOUT_2", E))(L || {}), N = /* @__PURE__ */ ((E) => (E.THEATRE_MODE = "THEATRE_MODE", E.FULLSCREEN_MODE = "FULLSCREEN_MODE", E.FULLSCREEN_WITHOUT_CONTROLS = "FULLSCREEN_WITHOUT_CONTROLS", E))(N || {});
const A = {
  width: "540px",
  height: "650px"
};
var r = /* @__PURE__ */ ((E) => (E.ONLINE = "ONLINE", E.OFFLINE = "OFFLINE", E))(r || {});
export {
  T as ContentOrientation,
  r as ContestSubmissionMode,
  L as FlipBookPageHeaderLayoutType,
  O as FlipBookPageType,
  N as FlipBookVideoPageType,
  A as defaultFlipBookPageDimensions
};
